/**
 * Link List Javascript
 */
import { Component, registerComponent } from 'js/component.js';
import { getViewportSize, throttle } from 'js/helpers.js';
const componentName = 'link-list';

class LinkList extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        toggle: this.element.querySelector(`button.${componentName}__toggle`),
        list: this.element.querySelector(`ul.${componentName}__list`),
    };

    // Util & State
    isExpandEnabled = () => this.elements.container?.classList.contains('collapse-mobile');
    isExpanded = () => this.elements.toggle.getAttribute('aria-expanded') === 'true';
    resizeThrottleMs = 100;
    listMaxHeight = '1000px';
    desktopTouched = false;

    /**
     * Toggle List
     */
    toggleList = () => {
        const newToggleVal = this.isExpanded() ? 'false' : 'true';
        const newListVal = this.isExpanded() ? 'true' : 'false';

        this.elements.toggle.setAttribute('aria-expanded', newToggleVal);
        this.elements.list.setAttribute('aria-hidden', newListVal);

        this.setListMaxHeight();
    };

    /**
     * Close List on Mobile
     */
    closeMobileList() {
        this.elements.list.style.maxHeight = '0';
        this.elements.toggle.setAttribute('aria-expanded', 'false');
        this.elements.list.setAttribute('aria-hidden', 'true');
    }

    /**
     * Close List on Desktop
     */
    closeDesktopList() {
        this.elements.list.style.maxHeight = null;
        this.elements.toggle.setAttribute('aria-expanded', 'true');
        this.elements.list.setAttribute('aria-hidden', 'false');
    }

    /**
     * Update List on Resize
     */
    updateListOnResize = () => {
        if(getViewportSize() === 'mobile') {
            this.updateListMaxHeight();
            if(this.desktopTouched) {
                this.closeMobileList();
                this.desktopTouched = false;
            }
        } else {
            this.desktopTouched = true;
            this.closeDesktopList();
        }
    };

    /**
     * Update List Height
     * - enables smooth max-height transition
     */
    updateListMaxHeight = () => {
        this.listMaxHeight = this.isExpanded() ? this.elements.list.offsetHeight : this.listMaxHeight;
    };

    /**
     * Set List Element Max Height Style
     */
    setListMaxHeight = () => {
        this.elements.list.style.maxHeight = this.isExpanded() ? `${this.listMaxHeight}px` : '0';
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        // Attach Listeners
        window.addEventListener('resize', throttle(this.updateListOnResize, this.resizeThrottleMs));
        this.elements.toggle.addEventListener('click', this.toggleList);
    };

    /**
     * Initialize Component
     */
    init() {
        // Fire Init Funcs
        if(!this.isExpandEnabled()) return;
        if(this.isExpanded && getViewportSize() === 'mobile') {
            this.updateListMaxHeight();
            this.setListMaxHeight();
            this.closeMobileList();
        }
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, LinkList);
